import { Box, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  FaExclamationCircle,
  FaQuestionCircle,
  FaBook,
  FaVideo,
} from "react-icons/fa";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { useContext } from "react";
import { AuthContext } from "../../providers/AuthValidationLayer";

const SupportCenter = () => {
  const { hasPermission } = useContext(AuthContext);
  
  const cardData = [
    {
      id: 1,
      title: "Complaints",
      description: "Manage and resolve customer complaints",
      icon: FaExclamationCircle,
      link: "/support/complaints",
      bgColor: "#FFE0EB",
      color: "#FF82AC",
      permission: { heading: "Support Center", subHeading: "Complaints" },
    },
    {
      id: 2,
      title: "FAQs",
      description: "Frequently asked questions and answers",
      icon: FaQuestionCircle,
      link: "/support/faqs",
      bgColor: "#E7EDFF",
      color: "#396AFF",
      permission: { heading: "Support Center", subHeading: "FAQs" },
    },
    {
      id: 3,
      title: "Knowledge Base",
      description: "Documentation and help articles",
      icon: FaBook,
      link: "/support/knowledge-base",
      bgColor: "#DCFAF8",
      color: "#00B69B",
      permission: { heading: "Support Center", subHeading: "Knowledge Base" },
    },
    {
      id: 4,
      title: "Training Videos",
      description: "Video tutorials and guides",
      icon: FaVideo,
      link: "/support/training-videos",
      bgColor: "#FFF5D9",
      color: "#FFBB38",
      permission: { heading: "Support Center", subHeading: "Training Videos" },
    },
  ];

  return (
    <Box px={4} py={6}>
      <BreadCrumbMaker items={[{ link: "#", title: "Support Center", on: true }]} />
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(2, 1fr)",
          lg: "repeat(4, 1fr)",
        }}
        gap={6}
      >
        {cardData
          .filter((card) =>
            hasPermission(
              card.permission.heading,
              card.permission.subHeading,
              "GET",
            ),
          )
          .map((card) => (
            <GridItem key={card.id}>
              <Link to={card.link}>
                <Box
                  bg="white"
                  p={6}
                  textAlign="center"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  h="200px"
                  gap={3}
                  borderRadius="3xl"
                  border="1px solid #D0D5DD"
                  borderColor="gray.200"
                  transition="all 0.2s ease"
                  _hover={{
                    borderColor: "blue.400",
                    boxShadow: "md",
                    transform: "translateY(-2px)",
                  }}
                >
                  <Box
                    bg={card.bgColor}
                    w={16}
                    h={16}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="full"
                  >
                    <Icon as={card.icon} boxSize={7} color={card.color} />
                  </Box>
                  <Text fontSize="18px" fontWeight="semibold" color="gray.700">
                    {card.title}
                  </Text>
                  <Text fontSize="13px" color="gray.500" textAlign="center">
                    {card.description}
                  </Text>
                </Box>
              </Link>
            </GridItem>
          ))}
      </Grid>
    </Box>
  );
};

export default SupportCenter;
